module.exports = __webpack_public_path__ + "static/media/facebook-logo.ffbaaf33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-logo.svg
// module id = 1694
// module chunks = 0